import { defineStore } from 'pinia'
import { getWalletProducts } from '@/service/wallet'

function readProductListFromStorage() {
  try {
    const raw = localStorage.getItem('product_list')
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : null
  } catch {
    return null
  }
}

export const useWalletStore = defineStore('wallet', {
  // state中定义数据
  state: () => ({
    productList: readProductListFromStorage()
  }),
  // 2. 计算属性
  getters: {
    vipWeekItem: (state) => {
      if (state.productList == null) {
        return null
      }
      return state.productList.find(item => item.id === 'vip_7days') || state.productList[0]
    }
  },
  // 3. 修改数据的方法
  actions: {
    async initProduct() {
      logger.debug('initProduct')

      let productResult = null
      try {
        productResult = await getWalletProducts()
      } catch (error) {
        logger.debug(error)
      }
      if (productResult) {
        logger.debug('initProduct productResult = ', productResult)
        const products = productResult.products
        this.productList = Array.isArray(products) ? products : []
        localStorage.setItem('product_list', JSON.stringify(this.productList))
      }
    }
  }
})
